import { useEffect, useRef } from 'react';
import { VideoStreamRenderer } from '@azure/communication-calling';
import "../componentStyle/ScreenSharingView.css"
import RenderDynamicView from "../RenderDynamicView";
import { appendRoleLabel, getParticipantRoleLabel } from "../utils/participantRoleUtils";

const ScreenSharingView = ({
  screenShareItem,
  participantItems,
  participantCount,
  pageIndex,
  localDisplayName,
  isAudioOnGoingLocal,
  getInitials,
  unmute_incall,
  mute_incall,
  localVideoStream,
  isVideoOnGoing,
  screenSharerUserId,
  userId,
  localParticipant = null
}) => {
  const localVideoPipContainerRef = useRef(null);
  const localVideoRef = useRef(null);

  useEffect(() => {
    let renderer;

    const renderStream = async () => {
      if (localVideoRef.current && localVideoStream && isVideoOnGoing) {
        try {
          renderer = new VideoStreamRenderer(localVideoStream);
          const view = await renderer.createView();
          if (localVideoRef.current) {
            localVideoRef.current.innerHTML = '';
            localVideoRef.current.appendChild(view.target);
          }
        } catch (e) {
          console.error('Failed to render local video stream in PiP', e);
        }
      } else if (localVideoRef.current) {
        localVideoRef.current.innerHTML = '';
      }
    };

    renderStream();

    return () => {
      if (renderer) {
        renderer.dispose();
      }
    };
  }, [localVideoStream, isVideoOnGoing]);

  return (
    <div key={screenShareItem.userId} className={`screen-share-layout ${screenShareItem ? "screen-sharing-active" : ""}`}>
      {screenShareItem && screenSharerUserId === userId ? (
        <div className="shared-screen-area">
          <div className="participant-video-placeholder">
            <div className="participant-video-placeholder-text">You are sharing your screen</div>
          </div>
        </div>
      ) : (
        <div className="shared-screen-area">
          <RenderDynamicView
            key={screenShareItem.userId}
            remoteVideoStream={screenShareItem.stream}
            item={screenShareItem}
            participantCount={participantCount}
            pageIndex={pageIndex}
            screenShareItem={screenShareItem}
            isScreenSharing={screenShareItem ? true : false}
          />
        </div>
      )}

      <div key={localDisplayName} className="participants-sidebar">
        <div className="local-video-in-share" ref={localVideoPipContainerRef}>
          {isVideoOnGoing ? (
            <>
              <div className="participant-video" ref={localVideoRef}></div>
              <img src={isAudioOnGoingLocal ? unmute_incall : mute_incall} className='own-mute-status' />
              <div className="short-name-in-share">
                {appendRoleLabel('You', getParticipantRoleLabel(localParticipant))}
              </div>
            </>
          ) : (
            <div className="participant-video-placeholder">
              <img src={isAudioOnGoingLocal ? unmute_incall : mute_incall} className='own- mute-status' />
              <div className="name_div">{getInitials ? getInitials(localDisplayName) : localDisplayName || "You"}</div>
            </div>
          )}
        </div>

        {/* Remote Participants */}
        {participantItems.map((item, index) => (
          <div key={`${item.userId}-${index}`} className="participant-user">
            <div className="participant-video">
              <RenderDynamicView
                item={item}
                remoteVideoStream={item.stream}
                participantCount={participantCount}
                pageIndex={pageIndex}
                isScreenSharing={screenShareItem ? true : false}
              />
            </div>
            <div className="participant-name">
              {appendRoleLabel(item.displayName, getParticipantRoleLabel(item))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ScreenSharingView;